import { useEffect, useRef, useState } from "react";
import { useAppContext } from "../functions/Context";
import {
  defaultScorecardMetadata,
  IScorecardMetadata,
} from "../models/ScorecardMetadata";
import { logger } from "../functions/Logger";

const useIndividualScorecard = (uid?: string): IScorecardMetadata => {
  const { store, api } = useAppContext();
  const [agreement, setAgreement] = useState<IScorecardMetadata>(
    defaultScorecardMetadata
  );
  const previousActiveId = useRef<string | null>(null);

  const me = store.auth.meJson;
  const activeId = store.scorecard.activeId;

  useEffect(() => {
    // Skip if no user is logged in
    if (!me) return;

    // Skip if activeId hasn't changed
    if (activeId === previousActiveId.current) return;

    // Update the ref to track the current activeId
    previousActiveId.current = activeId;

    const targetUid = uid || me.uid;

    const load = async () => {
      try {
        await api.individualScorecard.getByUid(targetUid);
      } catch (error) {
        logger.error(`Error fetching individual scorecard: ${error}`);
      }
    };

    load();
  }, [api.individualScorecard, me, uid, activeId]);

  useEffect(() => {
    if (!me) return;

    const targetUid = uid || me.uid;
    const storedAgreement = store.individualScorecard.getItemById(targetUid);

    if (!storedAgreement) return;

    setAgreement({
      ...defaultScorecardMetadata,
      ...storedAgreement.asJson,
      uid: targetUid,
    });
  }, [me, store.individualScorecard, store.individualScorecard.all, uid]);

  return agreement;
};

export default useIndividualScorecard;
